import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-code-question-circle-icon',
  templateUrl: './code-question-circle.component.html'
})
export class CodeQuestionCircleComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
